import { Component, inject, computed } from '@angular/core';
import { TableContext } from '../../../services/table/table-context.service';
import { NgClass } from '@angular/common';
import { NgIcon } from '@ng-icons/core';
@Component({
  selector: 'app-head-row',
  imports: [NgClass, NgIcon],
  templateUrl: './head-row.component.html',
  styleUrl: './head-row.component.scss',
})
export class HeadRowComponent {
  tableContext = inject(TableContext);
}
